/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DocumentTypeTranslation model module.
 * @module model/DocumentTypeTranslation
 * @version 1.0.0
 */
class DocumentTypeTranslation {
    /**
     * Constructs a new <code>DocumentTypeTranslation</code>.
     * @alias module:model/DocumentTypeTranslation
     * @param name {String} 
     * @param locale {String} 
     */
    constructor(name, locale) { 
        
        DocumentTypeTranslation.initialize(this, name, locale);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, locale) { 
        obj['name'] = name;
        obj['locale'] = locale;
    }

    /**
     * Constructs a <code>DocumentTypeTranslation</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DocumentTypeTranslation} obj Optional instance to populate.
     * @return {module:model/DocumentTypeTranslation} The populated <code>DocumentTypeTranslation</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DocumentTypeTranslation();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('locale')) {
                obj['locale'] = ApiClient.convertToType(data['locale'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} name
 */
DocumentTypeTranslation.prototype['name'] = undefined;

/**
 * @member {String} locale
 */
DocumentTypeTranslation.prototype['locale'] = undefined;






export default DocumentTypeTranslation;

